'use client';

import { useContext } from 'react';

import { ChatContext, type ChatContextValue } from '../contexts/chat/context';

export function useChatContext(): ChatContextValue {
  const ctx = useContext(ChatContext);
  if (ctx == null) {
    throw new Error('useChatContext must be used inside <ChatProvider>');
  }
  return ctx;
}
